export const demoConfig = {
  API: {
    ROOT_URL: () => 'https://apidemoa.econsulttest.health',
  },
  S3_BUCKET: `https://s3.eu-west-2.amazonaws.com/test-etriage.frontend.econsult.health/econsult-frontend/${process.env.REACT_APP_VERSION}/build`,
  SESSION_TIMEOUT: {
    IN_MINUTES: 20,
  },
};
